import { useEffect, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { api, eur } from "@/lib/api";
import PayseraPay from "@/components/shop/PayseraPay";
import { ExVat, Totals } from "@/components/shop/Totals";

export default function PayOrder() {
  const { id } = useParams();
  const { t } = useLang();
  const nav = useNavigate();
  const [o, setO] = useState(null);

  useEffect(() => {
    api.get(`/orders/${id}`).then((r) => setO(r.data)).catch(() => setO(false));
  }, [id]);

  if (o === null) return <div className="h-96" />;
  if (o === false) return <div className="text-center py-32 text-slate-400">404</div>;
  if (o.status !== "pending") return <Navigate to={`/order/${id}`} replace />;

  const buildOrder = async () => o;

  return (
    <div data-testid="pay-order-page" className="mx-auto max-w-2xl px-4 sm:px-6 py-16 rise">
      <h1 className="font-display font-black uppercase text-4xl sm:text-5xl tracking-tight">{t("pay_title")}</h1>
      <p className="text-slate-400 mt-3">{o.made_to_order ? t("pay_sub") : t("pay_sub_cart")}</p>
      {o.note && <p data-testid="pay-order-note" className="mt-6 border-l-2 border-orange-500 pl-4 text-slate-300 whitespace-pre-line">{o.note}</p>}
      <dl className="mt-8 border border-[#3B4157] divide-y divide-[#3B4157] text-sm">
        <div className="flex justify-between px-4 py-3"><dt className="text-slate-400">{t("order_no")}</dt><dd className="font-mono-x">{o.number}</dd></div>
        {o.items.map((i) => (
          <div key={i.product_id} className="px-4 py-3">
            <div className="flex justify-between"><dt>{i.quantity} × {i.name}</dt><dd className="font-mono-x whitespace-nowrap">{eur(i.price * i.quantity)}{o.subtotal != null && <ExVat />}</dd></div>
            {i.options?.length > 0 && <div className="text-xs text-slate-500 mt-1">+ {i.options.join(", ")}</div>}
          </div>
        ))}
        {o.made_to_order && <div className="flex justify-between px-4 py-3"><dt className="text-slate-400">{t("delivery_time")}</dt><dd>{t("up_to_14")}</dd></div>}
        {o.valid_until && <div className="flex justify-between px-4 py-3"><dt className="text-slate-400">{t("valid_until")}</dt><dd data-testid="pay-order-valid-until" className={`font-mono-x ${o.expired ? "text-red-400" : ""}`}>{o.valid_until.slice(0, 10)}</dd></div>}
        {o.subtotal != null ? <div className="px-4 py-3"><Totals net={o.subtotal} vat={o.vat} total={o.total} shipping={o.shipping} testid="pay-order-total" big="text-2xl" /></div>
          : <div className="flex justify-between px-4 py-3"><dt className="uppercase tracking-widest text-slate-400">{t("total")}</dt><dd data-testid="pay-order-total" className="font-display font-black text-2xl text-orange-500">{eur(o.total)}</dd></div>}
      </dl>
      {o.expired
        ? <p data-testid="pay-order-expired" className="mt-8 border-l-2 border-red-400 pl-4 text-red-300">{t("offer_expired")}</p>
        : <div className="mt-8 max-w-md"><PayseraPay buildOrder={buildOrder} onPaid={() => nav(`/order/${id}`)} /></div>}
    </div>
  );
}
